export class PrecipitationConverter {
	static toImperial(precipitation: number): number {
		return parseFloat((precipitation * 0.03937007875).toFixed(2));
	}

	static toMetric(precipitation: number): number {
		return parseFloat((precipitation * 25.4).toFixed(2));
	}
}

